import { render, staticRenderFns } from "./the-mass-actions-panels.vue?vue&type=template&id=84638434&"
import script from "./the-mass-actions-panels.vue?vue&type=script&lang=js&"
export * from "./the-mass-actions-panels.vue?vue&type=script&lang=js&"
import style0 from "./the-mass-actions-panels.vue?vue&type=style&index=0&id=84638434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports